<div class="fixed inset-0 z-[8000] bg-black/50 backdrop-blur-sm" (click)="onClose()"></div>

<div
  class="fixed top-0 right-0 z-[8001] h-dvh w-full max-w-[520px] bg-white dark:bg-surface-1 shadow-2xl flex flex-col"
  (click)="$event.stopPropagation()"
  id="model_form_panel"
>
  <!-- Header -->
  <div class="flex items-center justify-between px-6 py-5 border-b border-slate-100 dark:border-slate-700/60 shrink-0">
    <div class="flex items-center gap-3">
      <div class="w-8 h-8 rounded-lg bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center shadow-sm">
        <svg class="w-4 h-4 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="4" y="4" width="16" height="16" rx="2"></rect>
          <path d="M9 9h6v6H9z"></path>
          <path d="M9 1v3M15 1v3M9 20v3M15 20v3M1 9h3M1 15h3M20 9h3M20 15h3"></path>
        </svg>
      </div>
      <div>
        <h2 class="text-sm font-semibold text-slate-800 dark:text-white">
          {{ mode === 'create' ? 'New Model' : 'Edit Model' }}
        </h2>
        <p class="text-xs text-slate-400 dark:text-slate-500 mt-0.5">
          {{ mode === 'create' ? 'Add a realtime voice model to the catalog' : 'Update this model' }}
        </p>
      </div>
    </div>
    <button
      (click)="onClose()"
      class="flex items-center justify-center w-8 h-8 rounded-lg text-slate-400 hover:text-slate-700 dark:hover:text-white hover:bg-slate-100 dark:hover:bg-slate-700/60 transition-colors"
      id="model_panel_close_btn"
    >
      <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>

  <!-- Body -->
  <div class="flex-1 overflow-y-auto px-6 py-5 space-y-5">
    <div
      *ngIf="errorMessage()"
      class="p-3 rounded-xl bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800/50 text-xs text-red-700 dark:text-red-400"
      id="model_panel_error"
    >
      {{ errorMessage() }}
    </div>

    <!-- provider -->
    <div>
      <label class="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">
        Provider <span class="text-red-500">*</span>
      </label>
      <select
        [(ngModel)]="form.provider"
        class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/50
               text-sm text-slate-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-purple-500/40"
        id="model_panel_provider"
      >
        <option *ngFor="let provider of providers" [ngValue]="provider.value">{{ provider.label }}</option>
      </select>
    </div>

    <!-- model_code -->
    <div>
      <label class="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">
        Model code <span class="text-red-500">*</span>
      </label>
      <input
        type="text"
        [(ngModel)]="form.model_code"
        placeholder="gemini-3.1-flash-live-preview"
        class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/50
               text-sm text-slate-800 dark:text-white placeholder:text-slate-300 dark:placeholder:text-slate-600
               focus:outline-none focus:ring-2 focus:ring-purple-500/40 font-mono"
        id="model_panel_code"
      />
      <p class="text-[10px] text-slate-400 mt-1">
        The exact model id sent to the provider's API. Unique across the catalog.
      </p>
    </div>

    <!-- display_name -->
    <div>
      <label class="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">
        Display name <span class="text-red-500">*</span>
      </label>
      <input
        type="text"
        [(ngModel)]="form.display_name"
        placeholder="Gemini 3.1 Flash Live (Preview)"
        class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/50
               text-sm text-slate-800 dark:text-white placeholder:text-slate-300 dark:placeholder:text-slate-600
               focus:outline-none focus:ring-2 focus:ring-purple-500/40"
        id="model_panel_display_name"
      />
    </div>

    <!-- modality -->
    <div>
      <label class="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">
        Modality <span class="text-red-500">*</span>
      </label>
      <select
        [(ngModel)]="form.modality"
        class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/50
               text-sm text-slate-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-purple-500/40"
        id="model_panel_modality"
      >
        <option *ngFor="let modality of modalities" [ngValue]="modality">{{ modality }}</option>
      </select>
      <p class="text-[10px] text-slate-400 mt-1">
        native-audio = speech generated directly · half-cascade = text → TTS · realtime = OpenAI Realtime API.
      </p>
    </div>

    <!-- notes -->
    <div>
      <label class="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">
        Notes
      </label>
      <input
        type="text"
        [(ngModel)]="form.notes"
        placeholder="Why this model is in the catalog"
        class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/50
               text-sm text-slate-800 dark:text-white placeholder:text-slate-300 dark:placeholder:text-slate-600
               focus:outline-none focus:ring-2 focus:ring-purple-500/40"
        id="model_panel_notes"
      />
    </div>

    <!-- is_active -->
    <label
      class="flex items-start gap-3 p-3 rounded-xl border border-slate-200 dark:border-slate-700 cursor-pointer
             hover:bg-slate-50 dark:hover:bg-slate-800/40 transition-colors"
    >
      <input
        type="checkbox"
        [(ngModel)]="form.is_active"
        class="mt-0.5 w-4 h-4 rounded accent-emerald-600"
        id="model_panel_is_active"
      />
      <span>
        <span class="block text-xs font-semibold text-slate-700 dark:text-slate-200">Active</span>
        <span class="block text-[10px] text-slate-400 mt-0.5">
          Inactive models stay listed here but cannot be picked by prompts.
        </span>
      </span>
    </label>
  </div>

  <!-- Footer -->
  <div class="flex gap-3 px-6 py-4 border-t border-slate-100 dark:border-slate-700/60 shrink-0">
    <button
      (click)="onClose()"
      class="flex-1 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-medium
             text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors"
      id="model_panel_cancel_btn"
    >
      Cancel
    </button>
    <button
      (click)="onSubmit()"
      [disabled]="submitting()"
      class="flex-1 py-2.5 rounded-xl text-sm font-semibold text-white bg-gradient-to-r from-purple-500 to-indigo-600
             hover:from-purple-600 hover:to-indigo-700 disabled:opacity-60 transition-all active:scale-95"
      id="model_panel_submit_btn"
    >
      <span *ngIf="!submitting()">{{ mode === 'create' ? 'Add Model' : 'Save Changes' }}</span>
      <span *ngIf="submitting()" class="flex items-center justify-center gap-2">
        <span class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
        Saving…
      </span>
    </button>
  </div>
</div>
